import { $ } from "@/common/Axios";

export default {
  /**
   * 档案月完成情况
   */
  archiveMonthFinishInfo_batchRefresh: {
    /*
     * 批量刷新
     * startTime 开始时间 (string query required)
     */
    put: (p, c) =>
      $.put("/api/zms/archive/archiveMonthFinishInfo/batchRefresh", p, c),
  },
  archiveMonthFinishInfo_export: {
    /*
     * 导出
     */
    get: (p, c) =>
      $.get("/api/zms/archive/archiveMonthFinishInfo/export", p, c),
  },
  archiveMonthFinishInfo_finishInfo: {
    /*
     * 完成情况
     * month 月 (string query required)
     * year 年 (string query required)
     */
    get: (p, c) =>
      $.get("/api/zms/archive/archiveMonthFinishInfo/finishInfo", p, c),
  },
  archiveMonthFinishInfo_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/zms/archive/archiveMonthFinishInfo/list", p, c),
  },
  archiveMonthFinishInfo_listMonth: {
    /*
     * 月份列表
     * year 年 (string query required)
     */
    get: (p, c) =>
      $.get("/api/zms/archive/archiveMonthFinishInfo/listMonth", p, c),
  },
  archiveMonthFinishInfo_listYear: {
    /*
     * 年份列表
     */
    get: (p, c) =>
      $.get("/api/zms/archive/archiveMonthFinishInfo/listYear", p, c),
  },
  archiveMonthFinishInfo_refresh: {
    /*
     * 单个刷新
     * id id (integer query required)
     */
    put: (p, c) =>
      $.put("/api/zms/archive/archiveMonthFinishInfo/refresh", p, c),
  },

  /**
   * 档案模板
   */
  archiveTemplate: {
    /*
     * 添加
     * byClassRoom 根据班级 (string query )
     * bySite 根据学校 (string query )
     * byStudent 根据学生 (string query )
     * filePath 模板文件路径 (string query )
     * id  (integer query )
     * name 模板名称 (string query )
     * needTerm 是否需要学期筛选 (string query )
     * needTime 是否需要时间筛选 (string query )
     */
    post: (p, c) => $.post("/api/zms/archive/archiveTemplate", p, c),

    /*
     * 删除
     * id id (integer query required)
     */
    delete: (p, c) => $.delete("/api/zms/archive/archiveTemplate", p, c),
  },
  archiveTemplate_exportArchive: {
    /*
     * 档案导出
     * classRoomId 班级id (integer query )
     * end 结束时间 (string query )
     * name 模板名称 (string query required)
     * schoolRollId 合同id (integer query )
     * siteId 学校id (integer query )
     * start 开始时间 (string query )
     * term 学期 (integer query )
     * timeType 时间类型 (string query )
     */
    get: (p, c) =>
      $.get("/api/zms/archive/archiveTemplate/exportArchive", p, c),
  },
  archiveTemplate_exportArchiveForCont: {
    /*
     * 档案导出(职教学校平台)
     * classRoomId 班级id (integer query )
     * end 结束时间 (string query )
     * name 模板名称 (string query required)
     * schoolRollId 合同id (integer query )
     * start 开始时间 (string query )
     * term 学期 (integer query )
     * timeType 时间类型 (string query )
     */
    get: (p, c) =>
      $.get("/api/zms/archive/archiveTemplate/exportArchiveForCont", p, c),
  },
  archiveTemplate_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/zms/archive/archiveTemplate/list", p, c),
  },
  archiveTemplate_listForCont: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/zms/archive/archiveTemplate/listForCont", p, c),
  },

  /**
   * 档案周完成情况
   */
  archiveWeekFinishInfo_batchRefresh: {
    /*
     * 批量刷新
     * startTime 开始时间 (string query required)
     */
    put: (p, c) =>
      $.put("/api/zms/archive/archiveWeekFinishInfo/batchRefresh", p, c),
  },
  archiveWeekFinishInfo_export: {
    /*
     * 导出
     */
    get: (p, c) => $.get("/api/zms/archive/archiveWeekFinishInfo/export", p, c),
  },
  archiveWeekFinishInfo_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/zms/archive/archiveWeekFinishInfo/list", p, c),
  },
  archiveWeekFinishInfo_refresh: {
    /*
     * 单个刷新
     * id id (integer query required)
     */
    put: (p, c) =>
      $.put("/api/zms/archive/archiveWeekFinishInfo/refresh", p, c),
  },

  /**
   * 职教寝室
   */
  bedroom: {
    /*
     * 添加
     * halls 宿舍楼 (string query )
     * headId 寝室长(合同id) (integer query )
     * id  (integer query )
     * roomNum 房号 (string query )
     * siteId 学校id (integer query )
     */
    post: (p, c) => $.post("/api/zms/archive/bedroom", p, c),

    /*
     * 删除
     * id id (integer query required)
     */
    delete: (p, c) => $.delete("/api/zms/archive/bedroom", p, c),
  },
  bedroom_export: {
    /*
     * 导出
     */
    get: (p, c) => $.get("/api/zms/archive/bedroom/export", p, c),
  },
  bedroom_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/zms/archive/bedroom/list", p, c),
  },
  bedroom_listHalls: {
    /*
     * 楼栋列表
     * siteId 学校id (integer query required)
     */
    get: (p, c) => $.get("/api/zms/archive/bedroom/listHalls", p, c),
  },
  bedroom_listSimple: {
    /*
     * 简易列表
     * halls 宿舍楼 (string query required)
     * siteId 学校id (integer query required)
     */
    get: (p, c) => $.get("/api/zms/archive/bedroom/listSimple", p, c),
  },
  bedroom_uploadHead: {
    /*
     * 导入修改寝室长
     * file file (file formData required)
     */
    post: (p, c) => $.post("/api/zms/archive/bedroom/uploadHead", p, c),
  },

  /**
   * 职教证书
   */
  cert: {
    /*
     * 添加
     * adminId 添加人 (integer query )
     * attachId 附件id (integer query )
     * certTime 证书时间 (string query )
     * id  (integer query )
     * name 证书名称 (string query )
     * schoolRollId 合同id (integer query )
     * score 成绩 (integer query )
     */
    post: (p, c) => $.post("/api/zms/archive/cert", p, c),
  },
  cert_listBySchoolRollId: {
    /*
     * 根据合同id查询
     * schoolRollId 合同id (integer query required)
     */
    get: (p, c) => $.get("/api/zms/archive/cert/listBySchoolRollId", p, c),
  },

  /**
   * 班团干部
   */
  classCadre: {
    /*
     * 添加
     * classRoomId 班级id (integer query )
     * id  (integer query )
     * position 职位 (string query )
     * schoolRollId 合同id (integer query )
     * type 类型：班委、团委 (string query )
     */
    post: (p, c) => $.post("/api/zms/archive/classCadre", p, c),

    /*
     * 删除
     * id id (integer query required)
     */
    delete: (p, c) => $.delete("/api/zms/archive/classCadre", p, c),
  },
  classCadre_export: {
    /*
     * 导出
     */
    get: (p, c) => $.get("/api/zms/archive/classCadre/export", p, c),
  },
  classCadre_exportForCont: {
    /*
     * 导出(职教学校平台)
     */
    get: (p, c) => $.get("/api/zms/archive/classCadre/exportForCont", p, c),
  },
  classCadre_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/zms/archive/classCadre/list", p, c),
  },
  classCadre_listForCont: {
    /*
     * 列表(职教学校平台domain)
     */
    get: (p, c) => $.get("/api/zms/archive/classCadre/listForCont", p, c),
  },
  classCadre_listPosition: {
    /*
     * 获取职位
     * type 类型 (string query required)
     */
    get: (p, c) => $.get("/api/zms/archive/classCadre/listPosition", p, c),
  },
  classCadre_listSimpleByStudent: {
    /*
     * 根据学生获取职位列表
     * classRoomId 班级id (integer query required)
     * schoolRollId 合同id (integer query required)
     */
    get: (p, c) =>
      $.get("/api/zms/archive/classCadre/listSimpleByStudent", p, c),
  },
  classCadre_setPosition: {
    /*
     * 设置职位
     * positions 职位 (array query required)
     * type 类型 (string query required)
     */
    put: (p, c) => $.put("/api/zms/archive/classCadre/setPosition", p, c),
  },
  classCadre_upload: {
    /*
     * 导入
     * file file (file formData required)
     */
    post: (p, c) => $.post("/api/zms/archive/classCadre/upload", p, c),
  },
  classCadre_uploadForCont: {
    /*
     * 导入(职教学校平台)
     * file file (file formData required)
     */
    post: (p, c) => $.post("/api/zms/archive/classCadre/uploadForCont", p, c),
  },

  /**
   * 职教班会
   */
  classMeeting: {
    /*
     * 添加
     * attach 附件 (string query )
     * classRoomId 班级id (integer query )
     * compere 主持人 (string query )
     * createId 添加人id (integer query )
     * id  (integer query )
     * joinMembers 参加人员 (string query )
     * meetingContent 会议内容 (string query )
     * meetingEffect 会议效果 (string query )
     * meetingPlace 会议地点 (string query )
     * meetingTime 会议时间 (string query )
     * meetingTopic 会议主题 (string query )
     * type 类型：主题班会、日常班会、班委会议 (string query )
     * weekTime 周次 (string query )
     */
    post: (p, c) => $.post("/api/zms/archive/classMeeting", p, c),

    /*
     * 删除
     * id id (integer query required)
     */
    delete: (p, c) => $.delete("/api/zms/archive/classMeeting", p, c),
  },
  classMeeting_countUnFinishClassRoom: {
    /*
     * 未完成班会的班级数量
     * headerTeacherId 班主任id (integer query )
     * siteIds 学校id (array query )
     * type 类型：日常班会、班委会议、主题班会 (string query )
     */
    get: (p, c) =>
      $.get("/api/zms/archive/classMeeting/countUnFinishClassRoom", p, c),
  },
  classMeeting_countUnFinishClassRoomForCont: {
    /*
     * 未完成班会的班级数量
     * headerTeacherId 班主任id (integer query )
     * type 类型：日常班会、班委会议、主题班会 (string query )
     */
    get: (p, c) =>
      $.get(
        "/api/zms/archive/classMeeting/countUnFinishClassRoomForCont",
        p,
        c
      ),
  },
  classMeeting_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/zms/archive/classMeeting/list", p, c),
  },
  classMeeting_listCont: {
    /*
     * 列表(职教学校平台)
     */
    get: (p, c) => $.get("/api/zms/archive/classMeeting/listCont", p, c),
  },
  classMeeting_listSimpleByClassRoomId: {
    /*
     * 根据班级id获取班会列表
     * classRoomId 班级id (integer query required)
     * endTime 结束时间 (string query )
     * startTime 开始时间 (string query )
     * timeType 时间类型 (string query )
     * type 类型 (string query required)
     */
    get: (p, c) =>
      $.get("/api/zms/archive/classMeeting/listSimpleByClassRoomId", p, c),
  },
  classMeeting_listUnFinishClassRoom: {
    /*
     * 未完成班会的班级
     * type 类型：日常班会、班委会议、主题班会 (string query )
     */
    get: (p, c) =>
      $.get("/api/zms/archive/classMeeting/listUnFinishClassRoom", p, c),
  },
  classMeeting_listUnFinishClassRoomForCont: {
    /*
     * 未完成班会的班级
     * type 类型：日常班会、班委会议、主题班会 (string query )
     */
    get: (p, c) =>
      $.get("/api/zms/archive/classMeeting/listUnFinishClassRoomForCont", p, c),
  },

  /**
   * 职教奖惩
   */
  incentive: {
    /*
     * 添加
     * adminId 添加人 (integer query )
     * attachId 附件id (integer query )
     * id  (integer query )
     * incentiveTime 奖惩时间 (string query )
     * name 事项名称 (string query )
     * schoolRollId 合同id (integer query )
     * type 类型：评奖评优、处分 (string query )
     */
    post: (p, c) => $.post("/api/zms/archive/incentive", p, c),
  },
  incentive_listBySchoolRollId: {
    /*
     * 根据合同id查询
     * schoolRollId 合同id (integer query required)
     */
    get: (p, c) => $.get("/api/zms/archive/incentive/listBySchoolRollId", p, c),
  },

  /**
   * 职教听课记录
   */
  lectures: {
    /*
     * 添加
     * attachId 附件id (integer query )
     * classRoomId 班级id (integer query )
     * createId 添加人 (integer query )
     * endTime 结束时间 (string query )
     * id  (integer query )
     * lectureContent 授课内容 (string query )
     * lectureSituation 讲师上课情况 (string query )
     * listeningEffect 学生听课效果 (string query )
     * startTime 开始时间 (string query )
     * teachingPlanId 教学计划id (integer query )
     */
    post: (p, c) => $.post("/api/zms/archive/lectures", p, c),

    /*
     * 删除
     * id id (integer query required)
     */
    delete: (p, c) => $.delete("/api/zms/archive/lectures", p, c),
  },
  lectures_export: {
    /*
     * 导出
     */
    get: (p, c) => $.get("/api/zms/archive/lectures/export", p, c),
  },
  lectures_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/zms/archive/lectures/list", p, c),
  },
  lectures_unfinishCount: {
    /*
     * 未完成数量
     * headerTeacherId 班主任id (integer query )
     * siteIds 学校id (array query )
     */
    get: (p, c) => $.get("/api/zms/archive/lectures/unfinishCount", p, c),
  },
  lectures_upload: {
    /*
     * 导入
     * file file (file formData required)
     */
    post: (p, c) => $.post("/api/zms/archive/lectures/upload", p, c),
  },

  /**
   * 职教谈话
   */
  talk: {
    /*
     * 添加
     * address 谈话地点 (string query )
     * adminId 谈话人 (integer query )
     * attachId 附件id (integer query )
     * content 谈话内容 (string query )
     * contentType 类型：聊天记录、截图录音 (string query )
     * id  (integer query )
     * latest 是否最近联系 (string query )
     * purpose 谈话目的 (string query )
     * result 谈话结果 (string query )
     * schoolRollId 合同id (integer query )
     * talkTime 谈话时间 (string query )
     * type 类型：重点学生跟进、日常跟进、家长跟进 (string query )
     * way 谈话方式 (string query )
     */
    post: (p, c) => $.post("/api/zms/archive/talk", p, c),

    /*
     * 修改
     * address 谈话地点 (string query )
     * adminId 谈话人 (integer query )
     * attachId 附件id (integer query )
     * content 谈话内容 (string query )
     * contentType 类型：聊天记录、截图录音 (string query )
     * id  (integer query )
     * latest 是否最近联系 (string query )
     * purpose 谈话目的 (string query )
     * result 谈话结果 (string query )
     * schoolRollId 合同id (integer query )
     * talkTime 谈话时间 (string query )
     * type 类型：重点学生跟进、日常跟进、家长跟进 (string query )
     * way 谈话方式 (string query )
     */
    put: (p, c) => $.put("/api/zms/archive/talk", p, c),

    /*
     * 删除
     * id id (integer query required)
     */
    delete: (p, c) => $.delete("/api/zms/archive/talk", p, c),
  },
  talk_countVipUnfinish: {
    /*
     * 统计重点学生每周谈话未完成人数
     * headerTeacherId 班主任id (integer query )
     * siteIds 学校id (array query )
     */
    get: (p, c) => $.get("/api/zms/archive/talk/countVipUnfinish", p, c),
  },
  talk_exportVipTalk: {
    /*
     * 重点跟进记录导出
     * classRoomId 班级id (integer query )
     * end 结束时间 (string query )
     * siteId 学校id (integer query )
     * start 开始时间 (string query )
     * timeType 时间类型 (string query )
     */
    get: (p, c) => $.get("/api/zms/archive/talk/exportVipTalk", p, c),
  },
  talk_finishInfo: {
    /*
     * 获取非重点学生每月联系情况
     * headerTeacherId 班主任id (integer query )
     * siteIds 学校id (array query )
     */
    get: (p, c) => $.get("/api/zms/archive/talk/finishInfo", p, c),
  },
  talk_finishParentInfo: {
    /*
     * 获取当月未联系家长数量
     * headerTeacherId 班主任id (integer query )
     * siteIds 学校id (array query )
     */
    get: (p, c) => $.get("/api/zms/archive/talk/finishParentInfo", p, c),
  },
  talk_listByTypeAndSchoolRollId: {
    /*
     * 根据类型和合同id查询
     * contentType 内容类型：聊天记录、截图录音 (string query required)
     * schoolRollId 合同id (integer query required)
     * type 类型：重点学生跟进、日常跟进、家长跟进 (string query required)
     */
    get: (p, c) =>
      $.get("/api/zms/archive/talk/listByTypeAndSchoolRollId", p, c),
  },
  talk_restore: {
    /*
     * 修复联系记录
     */
    put: (p, c) => $.put("/api/zms/archive/talk/restore", p, c),
  },

  /**
   * 职教与讲师交流记录
   */
  teacherComm: {
    /*
     * 添加
     * commContent 沟通内容 (string query )
     * commEffect 沟通效果 (string query )
     * commTime 沟通时间 (string query )
     * courseId 课程id (integer query )
     * createId 添加人id (integer query )
     * id  (integer query )
     * siteId 学校id (integer query )
     * teacherName 讲师姓名 (string query )
     */
    post: (p, c) => $.post("/api/zms/archive/teacherComm", p, c),

    /*
     * 删除
     * id id (integer query required)
     */
    delete: (p, c) => $.delete("/api/zms/archive/teacherComm", p, c),
  },
  teacherComm_countUnfinish: {
    /*
     * 本月未沟通老师数量
     */
    get: (p, c) => $.get("/api/zms/archive/teacherComm/countUnfinish", p, c),
  },
  teacherComm_export: {
    /*
     * 导出
     */
    get: (p, c) => $.get("/api/zms/archive/teacherComm/export", p, c),
  },
  teacherComm_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/zms/archive/teacherComm/list", p, c),
  },
  teacherComm_listUnfinish: {
    /*
     * 本月未沟通老师列表
     */
    get: (p, c) => $.get("/api/zms/archive/teacherComm/listUnfinish", p, c),
  },
  teacherComm_upload: {
    /*
     * 导入
     * file file (file formData required)
     */
    post: (p, c) => $.post("/api/zms/archive/teacherComm/upload", p, c),
  },

  /**
   * 班主任和讲师沟通名单
   */
  teacherCommRoster: {
    /*
     * 添加
     * courseId 课程id (integer query )
     * endTime 结束时间 (string query )
     * headerTeacherId 班主任id (integer query )
     * id  (integer query )
     * siteId 学校id (integer query )
     * startTime 开始时间 (string query )
     * teacherName 老师 (string query )
     */
    post: (p, c) => $.post("/api/zms/archive/teacherCommRoster", p, c),

    /*
     * 删除
     * ids ids (array query required)
     */
    delete: (p, c) => $.delete("/api/zms/archive/teacherCommRoster", p, c),
  },
  teacherCommRoster_copy: {
    /*
     * 复制
     * fromTime 源时间 (string query required)
     * siteId 学校id (integer query )
     * toTime 目标时间 (string query required)
     */
    post: (p, c) => $.post("/api/zms/archive/teacherCommRoster/copy", p, c),
  },
  teacherCommRoster_export: {
    /*
     * 导出
     */
    get: (p, c) => $.get("/api/zms/archive/teacherCommRoster/export", p, c),
  },
  teacherCommRoster_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/zms/archive/teacherCommRoster/list", p, c),
  },
  teacherCommRoster_listCourseByHeaderTeacher: {
    /*
     * 课程列表（班主任）
     * commTime 沟通时间 (string query required)
     * teacherName 老师姓名 (string query required)
     */
    get: (p, c) =>
      $.get(
        "/api/zms/archive/teacherCommRoster/listCourseByHeaderTeacher",
        p,
        c
      ),
  },
  teacherCommRoster_listTeacherByHeaderTeacher: {
    /*
     * 老师列表（班主任）
     * commTime 沟通时间 (string query required)
     */
    get: (p, c) =>
      $.get(
        "/api/zms/archive/teacherCommRoster/listTeacherByHeaderTeacher",
        p,
        c
      ),
  },
  teacherCommRoster_upload: {
    /*
     * 导入
     * file file (file formData required)
     */
    post: (p, c) => $.post("/api/zms/archive/teacherCommRoster/upload", p, c),
  },

  /**
   * 工作计划
   */
  workPlan: {
    /*
     * 添加
     * attachId 附件id (integer query )
     * classRoomId 班级id (integer query )
     * createId 添加人 (integer query )
     * endTime 结束时间 (string query )
     * id  (integer query )
     * planContent 计划内容 (string query )
     * remark 备注 (string query )
     * startTime 开始时间 (string query )
     * term 学期 (integer query )
     * type 类型：学期、周 (string query )
     * weekTime 周次 (integer query )
     */
    post: (p, c) => $.post("/api/zms/archive/workPlan", p, c),

    /*
     * 删除
     * id id (integer query required)
     */
    delete: (p, c) => $.delete("/api/zms/archive/workPlan", p, c),
  },
  workPlan_countUnFinishClassRoom: {
    /*
     * 未完成工作计划的班级数量
     * headerTeacherId 班主任id (integer query )
     * siteIds 学校id (array query )
     * timeType 类型：本周，下周 (string query required)
     */
    get: (p, c) =>
      $.get("/api/zms/archive/workPlan/countUnFinishClassRoom", p, c),
  },
  workPlan_countUnFinishClassRoomForFont: {
    /*
     * 未完成工作计划的班级数量
     * headerTeacherId 班主任id (integer query )
     * timeType 类型：本周，下周 (string query required)
     */
    get: (p, c) =>
      $.get("/api/zms/archive/workPlan/countUnFinishClassRoomForFont", p, c),
  },
  workPlan_export: {
    /*
     * 导出
     */
    get: (p, c) => $.get("/api/zms/archive/workPlan/export", p, c),
  },
  workPlan_exportForCont: {
    /*
     * 导出
     */
    get: (p, c) => $.get("/api/zms/archive/workPlan/exportForCont", p, c),
  },
  workPlan_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/zms/archive/workPlan/list", p, c),
  },
  workPlan_listForCont: {
    /*
     * 列表(职教学校平台)
     */
    get: (p, c) => $.get("/api/zms/archive/workPlan/listForCont", p, c),
  },
  workPlan_listUnFinishClassRoom: {
    /*
     * 未完成工作计划的班级
     * timeType 类型：本周，下周 (string query required)
     */
    get: (p, c) =>
      $.get("/api/zms/archive/workPlan/listUnFinishClassRoom", p, c),
  },
  workPlan_listUnFinishClassRoomForCont: {
    /*
     * 未完成工作计划的班级
     * timeType 类型：本周，下周 (string query required)
     */
    get: (p, c) =>
      $.get("/api/zms/archive/workPlan/listUnFinishClassRoomForCont", p, c),
  },
  workPlan_upload: {
    /*
     * 导入
     * file file (file formData required)
     */
    post: (p, c) => $.post("/api/zms/archive/workPlan/upload", p, c),
  },
  workPlan_uploadForCont: {
    /*
     * 导入
     * file file (file formData required)
     */
    post: (p, c) => $.post("/api/zms/archive/workPlan/uploadForCont", p, c),
  },
};
